export default "__VITE_PUBLIC_ASSET__f8db9468__"